import { Card, Divider } from 'antd';
import { Project } from 'data/terra/Project';
import React, { memo } from 'react';
import './ProjectItem.scss';
import ProjectListBackground from './ProjectListBackground';

type ProjectItemProps = {
  item: Project;
  onClick: (item: Project) => void;
};

const ProjectItem: React.FC<ProjectItemProps> = ({ item, onClick }) => {
  return (
    <div className={'project-item-container'}>
      <Card
        hoverable
        className={'project-item'}
        cover={
          <div>
            {item.logoUrl ? (
              <img
                src={item.logoUrl}
                alt="logo"
                className="project-list-item-image"
              />
            ) : (
              <div className="project-list-item-image">
                <ProjectListBackground projectName={item.projectName ?? ''} />
              </div>
            )}
            <Divider style={{ margin: '0' }} />
          </div>
        }
        onClick={() => onClick(item)}
      >
        <Card.Meta
          style={{ height: '56px' }}
          title={item.projectName}
          description={item.projectCode}
        />
      </Card>
    </div>
  );
};

export default memo(ProjectItem);
